export async function hasStorageAccess() {
  if (!document.requestStorageAccess) {
    return true;
  }

  if (await document.hasStorageAccess()) {
    return true;
  }

  try {
    const permission = await navigator.permissions.query({
      name: 'storage-access' as PermissionName,
    });
    if (!permission) return false;
    if (permission.state === 'granted') {
      try {
        await document.requestStorageAccess();
        return true;
      } catch (error) {
        return false;
      }
    }
  } catch (err) {
    console.error('failed to check storage access:', err);
  }
  return false;
}
